import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AccountService } from '../services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private accountService: AccountService,
        private messageService: MessageService, private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            const error = err.error?.descripcion || err.statusText;
            console.error(err);

            if ([401].includes(err.status) //&& this.accountService.userValue
            ) {
                // auto logout if 401 or 403 response returned from api
                //this.router.navigateByUrl('/');
                this.accountService.logout();
            }
            if ([403].includes(err.status) //&& this.accountService.userValue
            ) {
                this.router.navigateByUrl('accessdenied');
            }

            if ([400, 500].includes(err.status) && !request.headers.has('X-Skip-Error-Toast')) {
                const content = err.error?.content;
                if (content) {
                    this.messageService.add({ severity: 'error', summary: 'Aviso', detail: content });
                } else {
                    this.messageService.add({ severity: 'error', summary: 'Aviso', detail: error });
                }
            }

            return throwError(err);
        }))
    }
}